export const ADD_PROMO_CODE_SUCCESS = "ADD_PROMO_CODE_SUCCESS";
export const LIST_ALL_PROMO_CODES_SUCCESS = "LIST_ALL_PROMO_CODES_REQUEST_SUCCESS";
export const UPDATE_PROMO_CODE_SUCCESS = "UPDATE_PROMO_CODE_SUCCESS";
export const LIST_ALL_PROMO_CODES_REQUEST = "LIST_ALL_PROMO_CODES_REQUEST";
export const LIST_ALL_PROMO_CODES_FAILURE = "LIST_ALL_PROMO_CODES_FAILURE";
export const DELETE_PROMO_CODE_SUCCESS = "DELETE_PROMO_CODE_SUCCESS"; 
export const CREATE_PROMO_CODE_SUCCESS = "CREATE_PROMO_CODE_SUCCESS";
